import api from './index';
//
let exports = {};

//保存合同订单信息
exports.saveGoodsOrder = function (params, callback) {// 保存合同订单信息
    api.post('/goods/order/save/do')
    .data(params)
    .done(callback)
    .go();
};

//查询相同合同的订单商品数量
exports.getGoodsOrderItemQuantityByContractNoAndSkuId = function (params, callback) {// 根据原始合同编号和skuId获取订单商品数量
    api.post('/goods/order/item/quantity/get/by/contractNo/and/skuId')
    .data(params)
    .done(callback)
    .go();
};

//查询合同订单
exports.getGoodsOrderList = function (params, callback) {// 获取订单列表
    api.post('/goods/order/list/get')
    .data(params)
    .done(callback)
    .go();
};

//查询合同订单
exports.getGoodsOrderInfo = function (params, callback) {// 查询订单信息
    api.post('/goods/order/info/get')
    .data(params)
    .done(callback)
    .go();
};

exports.getGoodsOrderInfoForDownloadPdf = function (params, callback) {// 商品订单签名文件PDF下载数据
    api.post('/goods/order/info/for/deownload/pdf/get')
    .data(params)
    .done(callback)
    .go();
};
// 商品订单签名文件导出ESCEL
exports.getGoodsOrderInfoForDownloadExcel = function (params, callback) {
    api.post('/goods/order/info/for/download/excel/get')
    .data(params)
    .done(callback)
    .go();
};

//查询配货信息列表
exports.getOrderGoodsAllocItemListByOrderId = function (postData, callback) {// 配货信息列表
    api.post('/goods/order/alloc/item/list/get/by/orderId')
    .data(postData)
    .done(callback)
    .go();
};
//查询配货信息列表
exports.getOrderGoodsAllocItemPagedListByOrderId = function (postData, callback) {// 配货信息列表
    api.post('/goods/order/alloc/item/paged/list/get/by/orderId')
    .data(postData)
    .done(callback)
    .go();
};
//查询配货信息列表
exports.getOrderGoodsAllocDtoListByOrderId = function (postData, callback) {// 获取店铺配货信息列表
    api.post('/goods/order/alloc/dto/list/get/by/orderId')
    .data(postData)
    .done(callback)
    .go();
};

exports.getOrderGoodsRecvAddrByShopIdAndOrderId = function (postData, callback) {// 查询订单中是否有选中的店铺
    api.get('/goods/order/recv/addr/get/by/shopId/and/orderId')
    .params(postData)
    .done(callback)
    .go();
};

exports.getGoodsOrderItemList = function (postData, callback) {// 商品订单项列表
    api.post('/goods/order/item/list/get')
    .data(postData)
    .done(callback)
    .go();
};

exports.getGoodsOrderItemListForReceipt = function (postData, callback) {// 商品订单项列表
    api.post('/goods/order/item/list/for/receipt/get')
    .data(postData)
    .done(callback)
    .go();
};

//配货
exports.saveOrderGoodsAllocItems = function (postData, callback) {// 批量保存配货信息
    api.post('/goods/order/alloc/items/save/do')
    .data(postData)
    .done(callback)
    .go();
};
// 调减
exports.reduceGoodsAllocItemDo = function (postData, callback) {
    api.post('/goods/order/alloc/item/reduce/do')
    .data(postData)
    .done(callback)
    .go();
};

//订单动作
exports.doCancelGoodsOrder = function (postData, callback) {// 订单动作处理
    api.post('/goods/order/cancel/do')
    .data(postData)
    .done(callback)
    .go();
};

exports.updateGoodsOrderForSignConfirmed = function (postData, callback) {// 签字确认
    api.post('/goods/order/sign/confirmed/update/do')
    .data(postData)
    .done(callback)
    .go();
};

// ================== 商品订单操作记录 ====================
exports.getGoodsOrderRecordList = function (params, callback) {// 订单操作记录
    api.post('/goods/order/record/list/get')
    .data(params)
    .done(callback)
    .go();
};

// 保存评价信息
exports.saveOrderGoodsEval = function (postData, callback) {// 保存订单商品的评价
    api.post('/goods/order/eval/save/do')
    .data(postData)
    .done(callback)
    .go();
};

// 作废
exports.invalidateOrderGoodsAllocItem = function (params, callback) {// 作废配货信息
    api.post('/goods/order/alloc/item/invalidate/do')
    .data(params)
    .done(callback)
    .go();
};

// 获取配货信息中去重后的desireArriveDate
exports.getDistinctOrderGoodsAllocItemDesireArriveDateList = function (params, callback) {// 获取配货信息中去重后的desireArriveDate
    api.post('/goods/order/distinct/alloc/item/desireArriveDate/list/get')
    .data(params)
    .done(callback)
    .go();
};
// ---------------------------- 配货单 ----------------------
// 配货单列表
exports.getOrderGoodsAllocFormList = function (data, callback) {
    api.post('/goods/order/alloc/form/list/by/filter')
    .data(data)
    .done(callback)
    .go();
};
// 获取不分页的配货单信息
exports.getOrderGoodsAllocFromListByOrderId = function (postData, callback) {
    api.post('/goods/order/alloc/form/list/get/by/orderId')
    .data(postData)
    .done(callback)
    .go();
};
// 配货单详情
exports.getOrderGoodsAllocFormById = function (params, callback) {
    api.get('/goods/order/alloc/form/get/by/id')
    .params(params)
    .done(callback)
    .go();
};
// 配货单保存
exports.doSaveOrderGoodsAllocForm = function (data, callback) {
    api.post('/goods/order/alloc/form/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 配货单删除
exports.doDeleteOrderGoodsAllocForm = function (data, callback) {
    api.post('/goods/order/alloc/form/delete/do')
    .data(data)
    .done(callback)
    .go();
};
// 配货单发送
exports.doUpdateOrderGoodsAllocFormState = function (data, callback) {
    api.post('/goods/order/alloc/form/update/state/do')
    .data(data)
    .done(callback)
    .go();
};
// 配货单撤回
exports.doCancelOrderGoodsAllocForm = function (data, callback) {
    api.post('/goods/order/alloc/form/cancel/do')
    .data(data)
    .done(callback)
    .go();
};
// 下载配货模板
exports.allocFormTemplateForExport = function (data, callback) {
    api.post('/goods/order/alloc/form/template/for/export/url')
    .data(data)
    .done(callback)
    .go();
};
// 配货导入校验
exports.validateOrderGoodsAllocFormImpTemplate = function (data, callback) {
    api.post('/goods/order/alloc/form/imp/template/validate')
    .data(data)
    .done(callback)
    .go();
};
// 配货导入
exports.doImportOrderGoodsAllocForms = function (data, callback) {
    api.post('/goods/order/alloc/forms/import/do')
    .data(data)
    .done(callback)
    .go();
};
// 配货导出
exports.allocFormImpModelForExport = function (data, callback) {
    api.post('/goods/order/alloc/form/model/for/export/url')
    .data(data)
    .done(callback)
    .go();
};

exports.doGoodsOrderShipAborted = function (data, callback) {
    api.post('/goods/order/ship/aborted/do')
    .data(data)
    .done(callback)
    .go();
};

exports.getGoodsOrderApdxFileList = function (data, callback) {
    api.post('/goods/order/apdx/img/file/list')
    .data(data)
    .done(callback)
    .go();
};

exports.deleteGoodsOrderApdxFile = function (data, callback) {
    api.post('/goods/order/apdx/img/file/delete')
    .data(data)
    .done(callback)
    .go();
};
exports.updateGoodsOrderApdxFile = function (data, callback) {
    api.post('/goods/order/apdx/img/file/update')
    .data(data)
    .done(callback)
    .go();
};
exports.getGoodsOrderApdxFileById = function (data, callback) {
    api.get('/goods/order/apdx/img/file/get/by/id')
    .params(data)
    .done(callback)
    .go();
};
exports.saveGoodsOrderApdxFile = function (data, callback) {
    api.post('/goods/order/apdx/img/file/save/do')
    .data(data)
    .done(callback)
    .go();
};

exports.genGoodsOrderOrigFile = function (data, callback) {
    api.post('/goods/order/genGoodsOrderOrigFile')
        .data(data)
        .done(callback)
        .go();
};


export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/goodsOrder.js
// module id = 53
// module chunks = 0